import React from 'react';
import { Col, Input } from 'reactstrap';

export const getActionOptions = (
  flexias,
  typeOfAttendant,
  inTheFlexIAs,
  action,
  setDataModal
) => {
  const selectedFlexias = flexias?.filter((flexia) =>
    inTheFlexIAs?.includes(flexia.id)
  );

  const isOnlyDialog =
    typeOfAttendant === 'FlexIA' &&
    (selectedFlexias?.filter((flexia) => flexia.type != 'DIALOG') ?? [])
      .length === 0 &&
    (selectedFlexias?.filter((flexia) => flexia.type === 'DIALOG') ?? [])
      .length > 0;

  return (
    <Col
      md={`${action === 'transferir' ? 2 : 4}`}
      style={{
        marginBottom: '10px'
      }}
    >
      <label>Ação:</label>
      <Input
        type="select"
        onChange={(event) => {
          try {
            if (typeof setDataModal === 'function') {
              if ((setDataModal.length || 0) >= 3) {
                setDataModal(event, null, 'action');
              } else {
                setDataModal({ value: event.target.value }, 'action');
              }
            }
          } catch (e) {
            // fallback simples
            setDataModal(event);
          }
        }}
        name="action"
        value={action}
      >
        <option value="encerrar">Encerrar</option>
        {isOnlyDialog ? (
          <>
            <option value="transferir">Transferir para outra fila</option>
            <option value="transferir_para_fila_do_no">
              Transferir para a fila do nó
            </option>
          </>
        ) : (
          <option value="transferir">Transferir</option>
        )}
      </Input>
    </Col>
  );
};
